export const pbxLocationsEn = {
  header: `Locations`,
  headerSubtext: `Manage office locations on this PBX. Each location maps to an E911 phone number that will be used as the caller ID for emergency calls.`,
  addLocation: `Add Location`,
  searchPlaceholder: `Search locations`,
  empty: `No locations configured for this PBX yet.`,
  loadError: `Failed to load locations.`,
  column: {
    name: `Name`,
    extensionCount: `Extensions`,
    e911Number: `E911 Number`,
    e911Address: `E911 Address`,
    actions: `Actions`,
  },
  notConfigured: `Not configured`,
  notConfiguredE911Number: `No E911 number assigned`,
  notConfiguredE911Address: `No E911 address on file`,
  edit: `Edit`,
  delete: `Delete`,
  extensionCountLabel_one: `{{count}} extension`,
  extensionCountLabel_other: `{{count}} extensions`,
  form: {
    createHeader: `Add Location`,
    editHeader: `Edit Location`,
    nameLabel: `Name`,
    namePlaceholder: `e.g. Main Office`,
    nameRequired: `Name is required`,
    phoneNumberLabel: `E911 Phone Number`,
    phoneNumberPlaceholder: `Select a phone number`,
    phoneNumberHelp: `This number's E911 address will be used for emergency calls placed from this location.`,
    noAvailableNumbers: `No phone numbers are available for assignment.`,
    loadingAvailableNumbers: `Loading available numbers...`,
    cancel: `Cancel`,
    save: `Save`,
    create: `Create Location`,
    update: `Update Location`,
    createSuccess: `Location created.`,
    updateSuccess: `Location updated.`,
    createError: `Failed to create location.`,
    updateError: `Failed to update location.`,
  },
  deleteModal: {
    header: `Delete Location`,
    confirmMessage: `Are you sure you want to delete "{{name}}"? This cannot be undone.`,
    reassignPrompt_one: `{{count}} extension is assigned to this location and must be reassigned before it can be deleted. Choose a new location:`,
    reassignPrompt_other: `{{count}} extensions are assigned to this location and must be reassigned before it can be deleted. Choose a new location:`,
    reassignSelectPlaceholder: `Select a destination location`,
    noOtherLocations: `There are no other locations on this PBX. Create another location first.`,
    cancel: `Cancel`,
    confirm: `Delete`,
    confirmReassign: `Reassign and Delete`,
    success: `Location deleted.`,
    error: `Failed to delete location.`,
  },
}

export type PbxLocationsLocale = typeof pbxLocationsEn
